import { render } from "./CascoRisksModal.vue?vue&type=template&id=985acd28"
import script from "./CascoRisksModal.vue?vue&type=script&lang=js"
export * from "./CascoRisksModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__